import Vue from "vue"
import Vuex from "vuex"

import Cart from "./modules/Cart";
import Shop from "./modules/Shop"

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    Cart: Cart,
    Shop: Shop
  }
});
